import { config } from '@/common';
import Funcs from '@/Func'

function Main(props: any) {
    const year_start = 2026
    const year = (new Date()).getFullYear()
    const configs = Funcs.getConfigs()
    return (
        <div className="copyright">
            技术支持
            <a href="https://mos01.com/" target='_blank'>魔思科技</a>
            © {(year === year_start) || `${year_start} - `}{year} {(configs.system && configs.system.name) || config.name}
            <a href="https://beian.miit.gov.cn/#/Integrated/index" target='_blank' rel="noreferrer">{(configs.system && configs.system.beian) || '鄂ICP备2024042762号-2'}</a>
        </div>
    )
}
export default Main